import React from 'react'
import { Link as RouterLink } from 'react-router-dom'
import Box from '@material-ui/core/Box'
import Button from '@material-ui/core/Button'
import LinearProgress from '@material-ui/core/LinearProgress'
import Typography from '@material-ui/core/Typography'
import { DateTime } from 'luxon'
import AddIcon from 'components/material-symbol/icons/Add'
import SocialShareDialog from 'components/social-share-dialog'
import ScheduleRow from './schedule-row'
import useStyles from './styles'

const getUpNextKey = bookings => {
  const now = DateTime.now()
  const active = bookings.filter(booking => !booking.isCanceled)
  const currentOrUpcoming = active.find(booking => {
    const end = DateTime.fromISO(booking.endDateTime).setZone(booking.timezone)
    return end > now
  })

  return currentOrUpcoming
    ? `${currentOrUpcoming.id}-${currentOrUpcoming.startDateTime}`
    : null
}

const TodaysSchedule = ({
  schedule,
  loading,
  shareUrl,
  onReschedule,
  onPayment,
  onCancellation,
}) => {
  const classes = useStyles()
  const today = DateTime.now()
  const activeSchedule = schedule.filter(booking => !booking.isCanceled)
  const sessionCount = activeSchedule.length
  const upNextKey = getUpNextKey(schedule)
  const subtitle = `${today.toFormat(
    'cccc, LLLL d',
  )} · ${sessionCount} session${sessionCount === 1 ? '' : 's'}`

  const listContent = (() => {
    if (loading) {
      return <LinearProgress color="primary" className={classes.loading} />
    }

    if (activeSchedule.length > 0) {
      return (
        <Box className={classes.list}>
          {activeSchedule.map(booking => (
            <ScheduleRow
              key={`${booking.id}-${booking.startDateTime}`}
              booking={booking}
              isUpNext={`${booking.id}-${booking.startDateTime}` === upNextKey}
              onReschedule={onReschedule}
              onPayment={onPayment}
              onCancellation={onCancellation}
            />
          ))}
        </Box>
      )
    }

    return (
      <Typography className={classes.emptyList}>
        No sessions scheduled for today.
      </Typography>
    )
  })()

  return (
    <Box className={classes.card}>
      <Box className={classes.header}>
        <Box>
          <Typography component="h2" className={classes.title}>
            Today&apos;s schedule
          </Typography>
          <Typography className={classes.subtitle}>{subtitle}</Typography>
        </Box>
        <Button
          component={RouterLink}
          to="/pga-coach/settings/availability"
          variant="outlined"
          className={classes.blockTimeButton}
          startIcon={<AddIcon />}
        >
          Block time
        </Button>
      </Box>

      {listContent}

      {shareUrl ? (
        <Box className={classes.footer}>
          <SocialShareDialog
            trigger={
              <Button
                variant="text"
                className={classes.footerButton}
                startIcon={<AddIcon aria-hidden />}
              >
                Share an Open Slot
              </Button>
            }
            shareUrl={shareUrl}
            shareTitle="Booking Link"
            showBookingUrl
            att="booking-link"
          />
        </Box>
      ) : null}
    </Box>
  )
}

export default TodaysSchedule
